import { render, staticRenderFns } from "./crowded.vue?vue&type=template&id=e7e7f2da&scoped=true&"
import script from "./crowded.vue?vue&type=script&lang=js&"
export * from "./crowded.vue?vue&type=script&lang=js&"
import style0 from "./crowded.vue?vue&type=style&index=0&id=e7e7f2da&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7e7f2da",
  null
  
)

export default component.exports